// libraries
import {useRouter} from 'next/router';
import {useTranslation} from 'react-i18next';
import React, {useEffect, useState} from 'react';
import resolveImage from '@helpers/resolve-image';
import Image from 'next/image';
import Link from 'next/link';
import {ethers} from 'ethers';
import Countdown from 'react-countdown';

// api
import {getItemById, getItemsV2, ItemInterface, OwnerItem} from '@api/item';
import {getUserByWalletAddress} from '@api/user';
import {votingNftStats, voteNft} from '@api/nusa';

// components
import LoadingSpinner from '@components/common/loading-spinner';
import {useApp} from '@components/providers/app-provider';
import {notifyText} from '@components/common/toast';
import Meta from '@components/common/Meta';

const Isff = () => {
  const {user, jwt: token} = useApp();
  const router = useRouter();
  const {t} = useTranslation(['collection', 'edit-profile']);

  // const voterCollectionId = 67; // testing
  const voterCollectionId = 45; // real

  const startDate = 'November 1 2023';
  const endDate = 'November 10 2023';
  const displayCountdown = new Date().valueOf() < new Date(startDate).valueOf();
  const displayVotes = new Date(endDate).valueOf() - new Date().valueOf() < 1;

  // countdown renderer
  const cdRenderer = ({days, hours, minutes, seconds, completed}: any) => {
    // return <span>{hours}:{minutes}:{seconds}</span>;
    return (
      <div className="bg-white/[.15] border border-jacarta-300 dark:border-jacarta-500 text-center py-4 lg:px-4 rounded-lg">
        <span className="font-semibold mr-2 text-left flex-auto">
          <span>
            {days} days {hours} hours {minutes} minutes
          </span>
        </span>
      </div>
    );
  };

  // states
  const films = [
    {
      id: 1,
      title: 'MBIYODO',
      image: '/images/movies/MBIYODO.png',
      description: `Bercerita tentang sekelompok penduduk desa yang melakukan "Mbiyodo" secara sukarela menyiapkan makanan di acara perkawinan. Berbagai pembicaraan, isu dan gosip menyebar di antara mereka. Tiba-tiba tamu pernikahan yang datang lebih banyak, hingga mereka mengetahui bahwa daging yang telah di simpan hilang. Misteri hilangnya daging menjadi masalah menarik dalam cerita ini.`,
      director: 'Raya Media Creative',
      cast: '',
      url: 'https://www.youtube.com/watch?v=R_MOUDJ_T2w&list=PLQ-LrAwyDa_nMgkf8Tkfrai5wOcJ0crai&index=16',
      date: '',
    },
    {
      id: 2,
      title: 'Misfocus',
      image: '/images/movies/Misfocus.png',
      description: `Mengisahkan seorang mahasiswa bernama "Langit" yang hobi mengambil gambar menggunakan kamera, di suatu ketika dia diminta untuk memfoto salah satu pengunjung cafe yg sering dia datangi.

Tanpa disadari ternyata di salah satu foto yang dia ambil Focus kamera mengarah ke perempuan yg ada di belakang pengunjung tersebut, dia pun ingin mencari tahu siapa perempuan tersebut.`,
      director: 'MERAKI CREATIVE HOUSE',
      cast: '',
      url: 'https://www.youtube.com/watch?v=0jxQCIob6u4&list=PLQ-LrAwyDa_nMgkf8Tkfrai5wOcJ0crai&index=4',
      date: '',
    },
    {
      id: 3,
      title: 'YELIM',
      image: '/images/movies/YELIM.png',
      description: `Mendengar Elan harus operasi dan kekurangan biaya, Ongen dilema membantu atau melanjutkan Keinginan membeli laptop dari hasil Tabungannya. Akankah Ongen membantu keluarga Elan?`,
      director: 'MAHIGAN',
      cast: '',
      url: 'https://www.youtube.com/watch?v=sHV_5WqISvA&list=PLQ-LrAwyDa_nMgkf8Tkfrai5wOcJ0crai&index=5',
      date: '',
    },
    {
      id: 4,
      title: 'Sisa Satu',
      image: '/images/movies/Sisa Satu.png',
      description: `Empat sekawan, Oleng, Aseng, Tejo, dan Pandi, sedang nongkrong di sebuah warkop milik Pandi. Ketika mereka sedang bermain karambol sambil bercanda, lewatlah seorang pedagang cilok di depan mereka. Mereka pun patungan untuk membeli cilok tersebut. Setelah mereka memakan cilok dengan lahap, tiba waktunya mereka untuk pulang, tetapi masih tersisa satu cilok terakhir. Oleng, Aseng, dan Tejo sangat ingin memakan cilok tersebut, hanya saja, mereka bertiga terlalu malu dan gengsi untuk memakan cilok terakhir tersebut. Pandi yang tidak peka menawarkan cilok terakhir tersebut pada mereka, tetapi mereka tidak ada yang menjawab. Tanpa pikir panjang Pandi pun langsung membuang cilok tersebut ke dalam tong sampah. Oleng, Aseng, dan Tejo sangat menyesal telah membiarkan cilok itu dibuang. Mereka pulang ke rumah masing-masing dengan keadaan tidak fokus karena terlalu memikirkan cilok yang dibuang Pandi. Hal-hal konyol pun terjadi selama mereka pulang. Keesokan harinya, mereka berempat berkumpul untuk nongkrong di warkop milik Pandi. Tak lama kemudian Pandi  datang dengan membawa makanan (piscok) ke meja mereka. Mereka pun makan dengan lahap. Kejadian serupa pun terulang kembali. Di waktu mereka hendak pulang, piscok yang ada di piring tersisa satu. Pandi menawarkan piscok tersebut kepada mereka bertiga. Lagi lagi, Oleng, Aseng, dan Tejo sangat ingin memakan piscok tersebut, hanya saja mereka terlalu malu untuk makan makanan terakhir. Pandi yang tidak peka langsung membawa piring tersebut untuk dibuang ke tong sampah. Oleng, Aseng, dan Tejo pun terjebak dalam dilema, membiarkan hal yang sebelumnya terjadi terulang atau mencegah Pandi. 
Akhirnya mereka bertiga berteriak memanggil dan mencegah Pandi membuang piscok tersebut. Mereka bertiga pun membagi satu piscok tersebut menjadi tiga dan makan dengan senang.`,
      director: 'Antus Films',
      cast: '',
      url: 'https://www.youtube.com/watch?v=EzzvRBY1vdI&list=PLQ-LrAwyDa_nMgkf8Tkfrai5wOcJ0crai&index=6',
      date: '',
    },
    {
      id: 5,
      title: 'SEMUA, DARA DIRAYAKAN',
      image: '/images/movies/SEMUA, DARA DIRAYAKAN.png',
      description: `Seorang wanita pengidap penyakit serius, yang berusaha bertahan dan menjalani hari-harinya.`,
      director: 'SELARASI FILM',
      cast: '',
      url: 'https://www.youtube.com/watch?v=kB8r9YvpGr8&list=PLQ-LrAwyDa_nMgkf8Tkfrai5wOcJ0crai&index=7',
      date: '',
    },
    {
      id: 6,
      title: 'Nada Irama',
      image: '/images/movies/Nada Irama.png',
      description: `Nadia adalah seorang penari berbakat muda, namun masa depan karirnya menjadi tidak pasti ketika dia menyadari bahwa dia mulai kehilangan indra pendengarannya.`,
      director: 'Unlimitale',
      cast: '',
      url: 'https://www.youtube.com/watch?v=QLXZvJbF7po&list=PLQ-LrAwyDa_nMgkf8Tkfrai5wOcJ0crai&index=15',
      date: '',
    },
    {
      id: 7,
      title: 'Gita Cita',
      image: '/images/movies/Gita Cita.jpg',
      description: `Cita bercita-cita menjadi seorang sutradara handal dan terkenal nantinya. Bersama teman-teman baiknya dia membuat film. Setelah lulus sekolah pun dia ingin kuliah sesuai dengan impiannya tersebut. Namun sayang setelah pengumuman kelulusan kedua orang tuanya telah memiliki rencana besar agar masa depannya terjamin. Yaitu dengan memaksanya untuk segera menikah. Hingga kejadian naas menimpa kedua orang tua Cita, membuat rencana besar mereka berubah total.`,
      director: 'Tim Wingit',
      cast: '',
      url: 'https://www.youtube.com/watch?v=EisDgqSRTWI&list=PLQ-LrAwyDa_nMgkf8Tkfrai5wOcJ0crai&index=8',
      date: '',
    },
    {
      id: 8,
      title: 'Ngangkot',
      image: '/images/movies/Ngangkot.png',
      description: `Iwan yang sedang terburu-buru berangkat ke sekolah untuk mengikuti ujian, menaiki angkot yang lumayan penuh, ia terhimpit di antara ibu hamil yang di dampingi suaminya dan ibu yang belanja banyak sayuran. Tiba-tiba ibu hamil tersebut mengalami pecah ketuban sehingga membuat para penumpang angkot pun panik. 

Mereka pun melakukan voting untuk mengantar ibu hamil tersebut terlebih dahulu atau tidak, karena beberapa dari mereka sedang terburu-buru seperti Iwan. Keseruan dan konflik pun terjadi ketika mereka terjebak macet dan supir angkot harus keluar dari jalurnya hingga terjadi adegan kejar-kejaran dengan dishub.

Apakah ibu hamil tersebut bisa sampai ke bidan dengan selamat? Dan apakah Iwan bisa sampai ke sekolah tepat waktu?`,
      director: 'Komunitas Film Bogor',
      cast: '',
      url: 'https://www.youtube.com/watch?v=Cu-p6m-IKXY&list=PLQ-LrAwyDa_nMgkf8Tkfrai5wOcJ0crai&index=2',
      date: '',
    },
    {
      id: 9,
      title: 'Mama+Papa+Surat Cinta=Aku',
      image: '/images/movies/MamaPapaSurat CintaAku.jpg',
      description: `Nindi ingin menikah, tapi khawatir dengan nasib bapaknya kalau Nindi tidak tinggal di rumah lagi, Nindi coba meyakinkan bapaknya untuk mencari pengganti mendiang ibunya`,
      director: 'Kamitetep Studio',
      cast: '',
      url: 'https://www.youtube.com/watch?v=IQhyCia2dX0&list=PLQ-LrAwyDa_nMgkf8Tkfrai5wOcJ0crai&index=16',
      date: '',
    },
    {
      id: 10,
      title: 'Surya Gemilang',
      image: '/images/movies/Surya Gemilang.jpg',
      description: `Jakarta, 2022, Mawar, penyanyi terkenal yang kini sedang berjuang melawan demensia, mengalami kebangkitan kembali kejayaannya di masa lalu ketika putranya yang berbakti, Tonny, membagikan album berharga dari konser ikoniknya di tahun 1984. Di tengah kenangan melankolis tentang dirinya yang lebih muda, Tina "Mawar", dan suaminya, Surya, emosi Mawar terjalin, menimbulkan kebingungan karena sesaat dia salah mengira Tonny sebagai mendiang suaminya. Dihadapkan pada kebenaran menyakitkan tentang ketidakhadiran Surya, Mawar diliputi rasa kehilangan dan kehampaan yang mendalam. Namun, pertemuan kebetulan dengan melodi jazz nostalgia dari pemutar vinil terdekat memicu transformasi halus dalam dirinya, dan dia dipandu oleh gema ritmis masa lalu, mengambil langkah tentatif kembali ke tarian ingatannya. Bersatu dengan Tonny di lantai dansa, Mawar menemukan pelipur lara dan kekuatan dalam mengobarkan kembali esensi asmara dengan Surya, merangkul momen-momen mesra yang hampir terlupakan.`,
      director: 'Surgem IKJ',
      cast: '',
      url: 'https://www.youtube.com/watch?v=iAho9VrJyhw&list=PLQ-LrAwyDa_nMgkf8Tkfrai5wOcJ0crai&index=10',
      date: '',
    },
    {
      id: 11,
      title: 'Taruh Nyawa',
      image: '/images/movies/Taruh Nyawa.jpg',
      description: `Menyelam melalui perspektif Rinjani (anak) dari keluarga yang hangat dan juga harmonis walau dengan segala kekurangannya. namun kehangatan itu hilang ketika mereka Diuji saat Bapak didiagnosa memiliki penyakit Alzheimer sedari lama, Bapak mulai bertingkah aneh dan membuat kekhawatiran untuk Rinjani dan ibu, polemik didalam keluarga pun terjadi ketika Ibu harus meninggal dunia karena kecelakaan saat berjualan Jamu dan bapak melihat dengan kepalanya sendiri, setelah dari kejadian tersebut bapak terus dihantui oleh rasa bersalahnya serta daya ingatnya yang semakin buruk semua ingatannya dimasa lalu tampak seperti terealisasikan lagi pada saat itu.
Sampai pada akhirnya Bapak menyusul kepergian ibu, dan Rinjani didiagnosa memiliki penyakit yang sama dengan Bapak yaitu Alzheimer. peluang untuk mendapatkan penyakit ini sebesar 50% untuk diturunkan kepada anaknya. Dan rinjani mendapatkan itu, Tentu bukan kabar yang baik bukan?
Apa Rinjani mampu melalui lila liku hidup yang akan semakin rumit kedepannya?`,
      director: 'jeevisuals',
      cast: '',
      url: 'https://www.youtube.com/watch?v=43VuIIOj0Eo&list=PLQ-LrAwyDa_nMgkf8Tkfrai5wOcJ0crai&index=11',
      date: '',
    },
    {
      id: 12,
      title: 'Tak Kentara',
      image: '/images/movies/Tak Kentara.jpg',
      description: `Adam, seorang anak yang lahir dari hubungan diluar pernikahan mengidap cerebral palsy. Kelainan Adam yang seakan menjadi alasan kepergian ibu, membuat Adam semakin hilang dalam bayang-bayang penyesalannya. Keterpurukan Adam membuatnya kesulitan untuk membedakan halusinasi dan kehidupan aslinya (skizofrenia). Halusinasi dan kehidupan asli Adam dicerminkan melalui perbedaan sudut pandang Adam sebagai manusia dan Bapak sebagai "Dia”. Dalam kehidupan asli sudut pandang Bapak menampilkan kasih sayang tak terbatas, sedangkan dalam bayangan Adam menggambarkan perasaan manusia yang membenci “Dia” karena kehidupannya tidak sesuai dengan apa yang diinginkan.`,
      director: 'Argani Films',
      cast: '',
      url: 'https://www.youtube.com/watch?v=jdZTuSGmkAM&list=PLQ-LrAwyDa_nMgkf8Tkfrai5wOcJ0crai&index=12',
      date: '',
    },
    {
      id: 13,
      title: 'Badut',
      image: '/images/movies/Badut.jpg',
      description: `Sudah lama berteman denganya dan perasaan aneh mulai muncul, ia menyukai temanku yaitu Dea, namun itu semua sudah terlambat, karna Dea sudah mempunyai pacar baru, aku semakin hari semakin heran karna sebenarnya aku ini sebagai apa dimata dea, teman, sahabat, atau sebagai`,
      director: 'Sixteen Production',
      cast: '',
      url: 'https://www.youtube.com/watch?v=apinxOjP0Jo&list=PLQ-LrAwyDa_nMgkf8Tkfrai5wOcJ0crai&index=3',
      date: '',
    },
    {
      id: 14,
      title: 'Perjalanan Adalah Hadiah',
      image: '/images/movies/Perjalanan Adalah Hadiah.jpg',
      description: `Film pendek 'Perjalanan Adalah Hadiah' merupakan film yang menceritakan perjalanan 4 sahabat Laras, Izzul, Ucup dan Gandi dari desa ke kota dengan bantuan petunjuk arah di handphone, untuk membelikan hadiah kepada wali kelas mereka. Namun ditengah perjalanan pulang, handphone yang digunakan sebagai petunjuk arah mati sehingga mereka tidak arah pulang.`,
      director: 'Seni Broadcasting & Film',
      cast: '',
      url: 'https://www.youtube.com/watch?v=UVtZOHIDG-M&list=PLQ-LrAwyDa_nMgkf8Tkfrai5wOcJ0crai&index=13',
      date: '',
    },
    {
      id: 15,
      title: 'The Neighbour',
      image: '/images/movies/The Neighbour.jpg',
      description: `In her scary boarding house, a woman lives in terror. She felt that she was always being stalked by a mysterious, unknown figure. The horror increased when she saw that her stalker was carrying a blood-stained plastic bag and a hammer in his hand. Until one night the stalker approached and even came close to her bedroom door.

However, what starts as a scary situation turns into unexpected comedy. The woman, who initially thought that she would be a victim, turned out that the stalker only wanted to ask for investment guidance from her. Because so far he has often seen her open the Indodax investment application with a good portfolio.`,
      director: 'Correlation Films',
      cast: '',
      url: 'https://www.youtube.com/watch?v=jHOGjFKezFg&list=PLQ-LrAwyDa_nMgkf8Tkfrai5wOcJ0crai&index=14',
      date: '',
    },
  ];
  const [isVoting, setIsVoting] = useState<Array<boolean>>([]);
  const [fetched, setFetched] = useState<boolean>(false);
  const [collectionDetail, setCollectionDetail] = useState<Array<ItemInterface> | null>(null);
  const [voterNft, setVoterNft] = useState<ItemInterface | null>(null);
  const [vote, setVote] = useState<any | null>(null);
  const [nftStats, setNftStats] = useState<any | null>(null);
  const [votePercentage, setVotePercentage] = useState<Array<number>>([]);

  async function fetchCollectionDetail() {
    // check if user own voter nft
    const res = await getItemsV2({
      owner: user?.wallet_address,
      collection_id: voterCollectionId,
      page: 1,
    });
    setCollectionDetail(res.records);

    if (res.records) {
      for (var i in res.records) {
        let c = res.records[i];
        setVoterNft(c);
        break;
      }
    }
  }

  async function fetchNftStats() {
    let res1 = await votingNftStats(1);
    if (res1) {
      let _nftStats = res1[0];
      for (var i in _nftStats.votes) {
        let userVote = _nftStats.votes[i];
        if (userVote.address.toLowerCase() == user?.wallet_address.toLowerCase()) {
          let _vote = films[userVote.vote - 1];
          _vote.date = new Date(userVote.timestamp * 1000).toISOString().split('T')[0];
          setVote(_vote);
          break;
        }
      }
      setNftStats(_nftStats);

      // count votes
      let totalVotes = _nftStats.votes.length;
      let voteCounts = Array(films.length).fill(0);
      let _votePercentage = Array(films.length).fill(0);
      for (var i in _nftStats.votes) {
        let userVote = _nftStats.votes[i];
        voteCounts[userVote.vote - 1]++;
      }
      for (var i in voteCounts) {
        _votePercentage[i] = ((voteCounts[i] / totalVotes) * 100).toFixed(2);
      }
      setVotePercentage(_votePercentage);
    }
  }

  const handleVote = async (index: number) => {
    let st: boolean[] = [];
    for (var i in films) {
      st[i] = films[i].id - 1 == index;
    }
    setIsVoting(st);

    const provider = new ethers.providers.Web3Provider(window.ethereum as any);
    await provider.send('eth_requestAccounts', []);
    const signer = provider.getSigner();
    const walletAddress = await signer.getAddress();

    var _vote = films[index];
    _vote.date = new Date().toISOString().split('T')[0];

    const voteMessage = {
      app: 'Nusa NFT',
      eventId: 1,
      title: _vote.title,
      vote: _vote.id,
      tokenId: voterNft?.tokenId,
      address: walletAddress,
      timestamp: Math.round(new Date().getTime() / 1000),
    };
    const signature = await signer.signMessage(JSON.stringify(voteMessage));
    const voteReq = {
      address: walletAddress,
      voteMessage: voteMessage,
      signature: signature,
    };

    let res = await voteNft(voteReq);
    if (!res || res.error || !res.result) {
      notifyText(false, 'Vote');
    } else {
      setVote(_vote);
      notifyText(true, 'Vote');
    }

    setIsVoting([]);
  };

  useEffect(() => {
    if (!nftStats) {
      fetchNftStats();
    }
    if (!user || !router.isReady || fetched) return;

    setFetched(true);

    if (!collectionDetail) {
      fetchCollectionDetail();
    }
  }, [user, nftStats, collectionDetail]);

  return (
    <>
      <Meta title="Voting ISFF || Nusa | NFT Marketplace" />
      <section className="relative mt-24 lg:pb-48 pb-24">
        <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
          <img src="/images/gradient_light.jpg" alt="gradient" className="h-full" />
        </picture>

        <div className="container">
          <div className="pt-7">
            <div className="text-md">INDODAX SHORT FILM FESTIVAL 2023</div>
            <div className="text-2xl font-bold text-green mb-5">WEB3 FAVORITE AWARD</div>

            <picture className="">
              <img src="/images/ISFF1.jpg" className="h-full" />
            </picture>

            {displayCountdown && (
              <div>
                <div className="text-center mt-5 mb-1">Event will start in:</div>
                <Countdown date={new Date(startDate)} renderer={cdRenderer}></Countdown>
              </div>
            )}

            {!displayCountdown && (
              <div>
                <div className="mt-5">
                  <div className="mt-5">
                    {!voterNft && (
                      <div className="bg-white/[.15] border border-jacarta-300 dark:border-jacarta-500 text-center py-4 lg:px-4 rounded-lg">
                        <div
                          className="p-2 bg-white/[.15] border border-jacarta-300 dark:border-jacarta-500 items-center text-gray-100 leading-none lg:rounded-full flex lg:inline-flex"
                          role="alert"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="24"
                            height="24"
                            className="fill-dark-navy mr-2 ml-2 mt-px h-4 w-4 shrink-0 dark:fill-white"
                          >
                            <path fill="none" d="M0 0h24v24H0z" />
                            <path d="M12.866 3l9.526 16.5a1 1 0 0 1-.866 1.5H2.474a1 1 0 0 1-.866-1.5L11.134 3a1 1 0 0 1 1.732 0zM11 16v2h2v-2h-2zm0-7v5h2V9h-2z" />
                          </svg>
                          <span className="font-semibold mr-2 text-left flex-auto">
                            In order to vote, you need to connect your wallet
                          </span>
                        </div>
                      </div>
                    )}
                    {voterNft && (
                      <div className="w-full py-2 px-4 bg-white/[.15] border border-jacarta-300 dark:border-jacarta-500 rounded-lg dark:bg-gray-800 dark:border-gray-700">
                        <div className="flow-root">
                          <ul role="list" className="divide-y divide-gray-200 dark:divide-gray-700">
                            <li className="py-2">
                              <div className="flex items-center space-x-4">
                                <div className="flex-shrink-0">
                                  <img
                                    className="w-20 h-20 rounded-sm"
                                    src={resolveImage(voterNft?.image)}
                                    alt="Voter NFT"
                                  />
                                </div>
                                <div className="flex-1 min-w-0">
                                  <div className="text-lg font-bold truncate text-green">
                                    {voterNft?.name}
                                  </div>
                                  <div className="mt-1 text-xs text-gray-500 truncate dark:text-gray-400">
                                    VOTE:{' '}
                                    <span className="text-gray-700 dark:text-jacarta-300">
                                      {vote && (
                                        <span className="italic">
                                          <span className="text-green font-bold">{vote.title}</span>{' '}
                                          on {vote.date}
                                        </span>
                                      )}
                                      {!vote && '[ - ]'}
                                    </span>
                                  </div>
                                </div>
                                <div className="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white"></div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="mt-5">
                  <div className="text-xl">Welcome to the ISFF Voter 2023!</div>
                  <div className="mt-2">
                    We proudly present the 15 best short films created by young Indonesian
                    filmmakers, which the Indodax Short Film Festival jury has curated.{' '}
                    <span className="font-bold">Each voter has only one opportunity to vote</span>.
                    Before proceeding with the voting process, please redeem the NFT{' '}
                    <span className="font-bold text-blue-light">#ISFFVoter</span> through this page:{' '}
                    <a
                      href="https://nft.nusa.finance/redeem"
                      target="_blank"
                      className="text-blue-light"
                      rel="noreferrer"
                    >
                      https://nft.nusa.finance/redeem
                    </a>
                    . For a guide on how to vote, you can refer to{' '}
                    <a
                      href="https://blog.indodax.com/isff-2023-open-for-voters/"
                      target="_blank"
                      className="font-bold text-blue-light"
                      rel="noreferrer"
                    >
                      *link*
                    </a>
                    .
                  </div>
                  <div className="mt-2">
                    The winner of the Web3 Favorite category will be announced at the Awarding Night
                    on November 10, 2023.
                  </div>
                </div>

                <div>
                  {films.map((item: any, index: number) => {
                    return (
                      <div
                        key={index}
                        className="flex flex-col border border-jacarta-300 rounded-lg shadow md:flex-row md:max-w-full mt-5 mb-5"
                      >
                        <img
                          className="object-cover w-full rounded-t-lg h-96 md:h-auto md:w-48 md:rounded-none md:rounded-l-lg"
                          src={item.image}
                        />
                        <div className="flex flex-col p-4 leading-normal" style={{width: '100%'}}>
                          <div className="flex flex-col md:flex-row items-center justify-between text-xl font-bold tracking-tight text-gray-900 dark:text-white">
                            <div>
                              {/*{ (index+1)+". " }*/}
                              <span>{item.title}</span>
                            </div>
                            <div className="pt-2 md:pt-1">
                              <a target="_blank" href={item.url} rel="noreferrer">
                                <button className="inline-flex mr-2 py-2 px-5 text-sm bg-transparent border border-green hover:bg-green hover:text-white rounded-full text-center font-semibold dark:text-white transition-all">
                                  ►<span className="ml-2">Watch</span>
                                </button>
                              </a>
                              {!displayVotes && !vote && (
                                <button
                                  disabled={isVoting[index] || !collectionDetail || !voterNft}
                                  onClick={() => handleVote(index)}
                                  className={
                                    isVoting[index]
                                      ? ' text-sm dark:bg-white/[.30] bg-light-grey py-2 px-5 border dark:border-white rounded-full text-center dark:text-white transition-all'
                                      : ' text-sm bg-green-gradation-light rounded-full py-2 px-5 text-center font-semibold text-white transition-all border border-green'
                                  }
                                >
                                  {isVoting[index] ? <LoadingSpinner /> : '+ Vote'}
                                </button>
                              )}
                              {vote && (
                                <button
                                  disabled={true}
                                  className={
                                    vote.id - 1 != index
                                      ? ' text-sm dark:bg-white/[.30] bg-light-grey py-2 px-5 border dark:border-white rounded-full text-center dark:text-white transition-all'
                                      : ' text-sm bg-green-gradation-light rounded-full py-2 px-5 text-center font-semibold text-white transition-all border border-green'
                                  }
                                >
                                  {vote.id - 1 != index ? (
                                    '+ Vote'
                                  ) : (
                                    <span>
                                      Voted{' '}
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        width="24"
                                        height="24"
                                        className="inline h-[.875rem] w-[.875rem] fill-white"
                                      >
                                        <path fill="none" d="M0 0h24v24H0z"></path>
                                        <path d="M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"></path>
                                      </svg>
                                    </span>
                                  )}
                                </button>
                              )}
                            </div>
                          </div>
                          <div className="mt-3 text-sm">
                            <span className="font-bold">Production Team: </span>
                            <span className="text-gray-700 dark:text-jacarta-300">
                              {item.director}
                            </span>
                            {/*{' | '}
                            <span className="font-bold">Cast: </span>
                            <span className="text-gray-700 dark:text-jacarta-300">{item.cast}</span>*/}
                            <div className="mt-3 mb-3 text-sm text-gray-700 dark:text-jacarta-300">
                              {item.description}
                            </div>
                          </div>
                          {displayVotes && (
                            <div className="text-sm">
                              <div className="mb-1 font-bold">
                                Vote: {votePercentage[index] ? votePercentage[index] + '%' : '-'}
                              </div>
                              <div className="bg-gray-200 border border-jacarta-300 rounded-full dark:border-jacarta-600 dark:bg-gray-700">
                                <div
                                  className="bg-green text-xs font-medium text-white text-center p-0.1 font-bold leading-none rounded-full"
                                  style={{
                                    width: votePercentage[index]
                                      ? votePercentage[index] + '%'
                                      : '0px',
                                  }}
                                >
                                  &nbsp;
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default Isff;
